import { render, staticRenderFns } from "./BlogTagManager.vue?vue&type=template&id=637cb6a5&scoped=true&"
import script from "./BlogTagManager.vue?vue&type=script&lang=js&"
export * from "./BlogTagManager.vue?vue&type=script&lang=js&"
import style0 from "./BlogTagManager.vue?vue&type=style&index=0&id=637cb6a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637cb6a5",
  null
  
)

export default component.exports